import { Footer } from "../components/Footer";
import { Nav } from "../components/Nav";
import ServiceDetails from "../components/ServiceDetails";
import { Seo } from "../components/Seo";

export default function ProjectManagement() {
	return (
		<>
			<Seo title="Civil Engineering Project Management | Gova" description="Coordinate design, agencies, utilities, permitting, and construction milestones for Central Texas development projects." path="/project-management" serviceName="Civil Engineering Project Management" />
			<Nav />
			<ServiceDetails
				service="project-management"
				onBack={() => window.history.back()}
			/>
			<Footer />
		</>
	);
}
